<template>
  <div class="node-viewer" :class="{hide: hideViewer}">
    <TopicViewer v-if="node.topic" :topic="node.topic"/>
    <NodeList v-else :parent="node.id"/>

  </div>
</template>

<script lang="ts">
import {computed, defineComponent, inject, PropType} from "vue";
import {INode} from "@/interfaces/evidence-map";
import NodeList from "@/components/NodeList.vue";
import TopicViewer from "@/components/TopicViewer.vue";
import {useMapStore} from "@/mixins/mapStore";

export default defineComponent({
  name: "NodeViewer",
  components: {TopicViewer, NodeList},
  props: {
    node: Object as PropType<INode>
  },
  setup(props) {
    const mapStore = useMapStore()
    const hideViewer = computed(() => mapStore.getNodesByParent(props.node.id).length == 1)
    return {
      hideViewer,
      mapStore
    }
  }
})
</script>
<style lang="scss">
@import "src/assets/styles/vars";

.node-viewer {
  height: 100%;
  width: 20vw;
  border-right: solid 0.5px $primary;

  &.hide {
    display: none;
  }
}
</style>